module.exports = __webpack_public_path__ + "static/media/invest-banner.2afec74e.png";